export default class RefundType {
  static get Manual () { return 'manual' }
  static get Automatic () { return 'automatic' }

  static getName (enumValue, deliveryType) {
    switch (enumValue) {
      case RefundType.Manual:
        return 'Вручную'
      case RefundType.Automatic:
        return 'По интеграции'
      default:
        return enumValue
    }
  }
}
